/**
 * @generated SignedSource<<bce28190ebe71adc451e9e98576723df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductFamily = "BUSINESS" | "ENTERPRISE" | "ENTERPRISE_PLUS" | "FEEDBACK" | "FREE" | "MEETING_RECORDER" | "OBJECTIVES" | "PRO" | "SOLOPRENEUR";
export type SubscriptionState = "POST_SUBSCRIBED" | "POST_TRIAL" | "SUBSCRIBED" | "TRIAL";
import { FragmentRefs } from "relay-runtime";
export type utils_useShouldShowUpgradeLink_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly product: {
        readonly family: ProductFamily;
      };
      readonly subscriptionStartDate: string | null;
      readonly subscriptionState: SubscriptionState;
    };
  };
  readonly dismissedElements: ReadonlyArray<{
    readonly id: string;
    readonly key: string;
  }>;
  readonly " $fragmentType": "utils_useShouldShowUpgradeLink_viewer";
};
export type utils_useShouldShowUpgradeLink_viewer$key = {
  readonly " $data"?: utils_useShouldShowUpgradeLink_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useShouldShowUpgradeLink_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "utils_useShouldShowUpgradeLink_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DismissedElement",
      "kind": "LinkedField",
      "name": "dismissedElements",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionState",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionStartDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "family",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "975f38d6bdb044bdb8c9cf87e790645f";

export default node;
